import React, {useState} from "react";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';

import noimage from 'assets/images/csango10-13kerulet-elado-lakasok-3.webp';
import clg from "functions/log";
import routes from "configs/routes";

const BlogListItem = ({title = null, image = null, timestamp=null, slug = null, loaded = false, containerClasses = null}) => {

    const [imageLoaded, setImageLoaded] = useState(false);

    const handleRedirect = (event) => {
        if( !loaded ) event.preventDefault();
    }

    return(
        <Link to={ ( slug ? routes.blogSingle.replace(":slug", slug) : "" ) } className={`${ ( containerClasses ? containerClasses + " blog-list-item" : "col-xl-4 col-lg-6 col-12 blog-list-item" ) }`} onClick={(e) => handleRedirect(e)}>
            <div className="inner">
                {
                    !loaded && (
                        <Skeleton height={250} className="mb-2"/>
                    )
                }
                {
                    loaded && (
                        <img src={image || noimage} alt={ title } className={ !imageLoaded ? "d-none" : "" } onLoad={() => setImageLoaded(true)}/>
                    )
                }
                {
                    (loaded && !imageLoaded) && (
                        <Skeleton height={250} className="mb-2"/>
                    )
                }
                
                <div className="details">
                    <div className="timestamp">{timestamp || <Skeleton width={70} />}</div>
                    <div className="title">{title || <><Skeleton width={"100%"}  /><Skeleton width={"80%"}  /></>}</div>
                </div>
            </div>
        </Link>
    )
}

export default BlogListItem;